module.exports = __webpack_public_path__ + "img/Elsa-Vallejos.c6cbcacf.png";